import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  SET_ERROR_ALERT,
  CLEAR_ALL_ERROR_ALERTS,
} from 'AppSrc/core/actions/actions-error-alert';



const errorAlertDefaultState = {
  currentErrors: [],
};


const setErrorAlert = (state, action) => {
  const {
    errorTitle,
    errorText,
  } = action.payload;

  return ({
    ...state,
    currentErrors: [
      ...state.currentErrors,
      {
        errorTitle,
        errorText,
      },
    ],
  });
};

const clearAllErrorAlerts = (state, action) => ({
  ...state,
  currentErrors: [],
});


const actionHandlers = {
  [SET_ERROR_ALERT]: setErrorAlert,
  [CLEAR_ALL_ERROR_ALERTS]: clearAllErrorAlerts,
};

const errorAlertReducer = createReducer(errorAlertDefaultState, actionHandlers);


export {
  errorAlertDefaultState,
  errorAlertReducer,
};





